import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import S from 'StyledForgotPasswordForm.js';
import { translation } from 'helpers/utilsHelper.js';
import { forgotPassword } from 'authActions.js';
import { useDispatch } from 'react-redux';
import useToggle from 'UseToggle.js';
import ModalOpacity from 'ModalOpacity.js';
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';

const validate = values => {
    const errors = validation(values, validators.FORGOT_PASSWORD);
    return errors;
};

const renderField = ({ input, label, type, meta: { touched, error, warning, submitFailed } }) => {

    return (
        <S.Row>
            <S.InputWrapper>
                <S.Input {...input} type={type} required="required" />
                <S.Label>{label}</S.Label>
                {(touched || submitFailed) && ((error && <S.Error className="text-ellipsis">{error[0]}</S.Error>) || (warning &&
                    <S.Error>{warning}</S.Error>))}
            </S.InputWrapper>
        </S.Row>
    );
};

const ForgotPasswordForm = (props) => {
    const { handleSubmit, submitting, error, submitSucceeded } = props;
    const dispatch = useDispatch();

    const forgotPasswordOnSubmit = async (postData) => {
        try {
            const user = await dispatch(forgotPassword(postData));
            return user;
        } catch (error) {
            throw error;
        }
    };

    const onFormSubmit = async (values) => {
        try {
            await forgotPasswordOnSubmit(values);
        } catch (err) {
            throw new SubmissionError({ _error: err });
        }
    };

    return (
        <S.ForgotPasswordForm method="post" onSubmit={handleSubmit(onFormSubmit)} autocomplete="off" noValidate>
          
          {submitSucceeded && <S.SubmissionSuccess>{translation('forgotPasswordForm_resetPasswordSuccess')}</S.SubmissionSuccess>}
          {error && <S.SubmissionError>{error}</S.SubmissionError>}
            <S.Info>{translation('forgotPasswordForm_text1')}</S.Info>
            <Field
                name="email"
                type="text"
                component={renderField}
                label={translation('account_forgotPassword_email')}
                disabled={submitSucceeded}
            />
            <S.SubmitButton type="submit" disabled={submitting||submitSucceeded}>{translation('forgotPasswordForm_recoverPassword')}</S.SubmitButton>
        </S.ForgotPasswordForm>
    );
};

export default reduxForm({
    form: 'forgotPassword',
    validate
})(ForgotPasswordForm);